import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Badge } from '../ui/badge';
import { Bot, Lock, Unlock, AlertTriangle } from 'lucide-react';

const DEVELOPER_PASSWORD = '050378';

const PasswordScreen = ({ onAuthenticate }) => {
  const [passwordInput, setPasswordInput] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === DEVELOPER_PASSWORD) {
      onAuthenticate(true);
      setPasswordError('');
      setPasswordInput('');
    } else {
      setPasswordError('Invalid password. Access denied.');
      setPasswordInput('');
    }
  };

  return (
    <div className="h-[calc(100vh-140px)] flex items-center justify-center">
      <Card 
        className="w-full max-w-md border-2 border-primary/30"
        style={{
          boxShadow: '0 0 30px rgba(59, 130, 246, 0.4), 0 0 60px rgba(59, 130, 246, 0.2)'
        }}
      >
        <CardHeader className="text-center pb-2">
          <div className="flex flex-col items-center gap-4">
            <div 
              className="h-20 w-20 rounded-full bg-primary/10 flex items-center justify-center border-2 border-primary/30"
              style={{
                boxShadow: '0 0 20px rgba(59, 130, 246, 0.3)'
              }}
            >
              <Bot className="h-10 w-10 text-primary" />
            </div>
            <div>
              <CardTitle className="text-2xl font-bold text-primary">Rhino-1 Enterprise</CardTitle>
              <CardDescription className="mt-2 text-base">
                Secret Development Project
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="pt-4">
          <div className="space-y-4">
            <div className="text-center">
              <Badge variant="outline" className="text-xs">
                <Lock className="h-3 w-3 mr-1" />
                Super Admin Developer Access Only
              </Badge>
            </div>
            <form onSubmit={handlePasswordSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="password">Enter Access Password</Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input
                    id="password"
                    type="password"
                    placeholder="••••••••••••"
                    value={passwordInput}
                    onChange={(e) => setPasswordInput(e.target.value)}
                    className="pl-10"
                    autoFocus
                  />
                </div>
                {passwordError && (
                  <p className="text-sm text-red-500 flex items-center gap-1">
                    <AlertTriangle className="h-3 w-3" />
                    {passwordError}
                  </p>
                )}
              </div>
              <Button type="submit" className="w-full">
                <Unlock className="h-4 w-4 mr-2" />
                Access Development Environment
              </Button>
            </form>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PasswordScreen;
